var _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDot = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 8,
  r: 7,
  fill: "currentColor",
  stroke: "currentColor",
  opacity: 0.3
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 8,
  r: 3,
  fill: "currentColor",
  stroke: "currentColor"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgDot);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/dot.3af592c33592e2f71993449c313ad939.svg";